import React from "react";
import { QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import queryClient from "reactQuery/client";

import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import ConfettiProvider from "contexts/Confetti/ConfettiProvider";
import { ModalProvider } from "contexts/ModalContext";
import PublicVisitorProvider from "contexts/PublicVisitorContext/PublicVisitorContext";
import { SnackBarProvider } from "contexts/Snackbar/SnackbarProvider";
import theme from "muiTheme";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider theme={theme}>
      <StyledEngineProvider injectFirst>
        <QueryClientProvider client={queryClient}>
          <PublicVisitorProvider>
            <ConfettiProvider>
              <SnackBarProvider>
                <>
                  <ReactQueryDevtools
                    initialIsOpen={false}
                    position="bottom-right"
                  />
                  <ModalProvider>{children}</ModalProvider>
                </>
              </SnackBarProvider>
            </ConfettiProvider>
          </PublicVisitorProvider>
        </QueryClientProvider>
      </StyledEngineProvider>
    </ThemeProvider>
  );
}
